module.exports = __webpack_public_path__ + "static/media/play-store.6f4c48a3.svg";